import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { CompanyMemberFullDecorator } from "lib/decorators/index";

const serializeCompanyMember = (member) => ({
  id: member.id,
  admin_user_attributes: member.admin_user,
  role: member.role,
});

export default new (class CompanyMembersRepository extends BaseRepository {
  find(id) {
    return this.api
      .get(`/company/members/${id}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((member) => new CompanyMemberFullDecorator(member));
  }

  findAll(params = {}) {
    const bucket = this.getBucket("company_members.index");
    const request$ = this.api
      .get(`/company/members`, { params })
      .map((response) => ({
        records: st.api
          .dejsonapinize(response.data.data, response.data.included)
          .map((member) => new CompanyMemberFullDecorator(member)),
        meta: response.data.meta,
      }));
    return this.mergeRequestWithCurrentBucketState(bucket, request$);
  }

  create(data) {
    const payload = {
      company_member: serializeCompanyMember(data),
    };
    return this.api
      .post(`/company/members`, payload)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((member) => new CompanyMemberFullDecorator(member));
  }

  update(data) {
    const payload = {
      company_member: serializeCompanyMember(data),
    };
    return this.api
      .put(`/company/members/${data.id}`, payload)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((member) => new CompanyMemberFullDecorator(member));
  }

  delete(id) {
    return this.api.delete(`/company/members/${id}`);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/CompanyMembersRepository.js